/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import formatMessage from '../../format-message';
const locale = { "cancel_caeb1e68": { "message": "Скасувати" }, "greek_65c5b3f7": { "message": "Грецький" }, "loading_25990131": { "message": "Завантаження..." }, "no_preview_is_available_for_this_file_f940114a": { "message": "Попередній перегляд  для цього файлу недоступний." }, "processing_8c569014": { "message": "Обробка..." }, "upload_8b403d05": { "message": "Завантажити" } };
formatMessage.addLocale({ 'uk-UA': locale });
